import { queryOptions, useSuspenseQuery, useQuery } from '@tanstack/react-query';
import httpv2 from 'apis/httpv2';
import { QueryConfig, PageDtoV2TransactionTypeRpt, PageAndSortParamsType } from 'types';

export interface TransactionTypesSearchParamsType extends PageAndSortParamsType {
  name?: string;
  type?: string;
  discontinued?: boolean;
  chartId?: number;
}

export const getTransactionTypes = (searchParams?: TransactionTypesSearchParamsType) => {
  return httpv2.get<PageDtoV2TransactionTypeRpt>('transaction-types', { params: searchParams });
};

export const getTransactionTypesQueryOptions = (searchParams?: TransactionTypesSearchParamsType) => {
  return queryOptions({
    queryKey: ['transaction-types', { searchParams }],
    queryFn: () => getTransactionTypes(searchParams),
  });
};

interface UseTransactionTypesOptions {
  queryConfig?: QueryConfig<typeof getTransactionTypesQueryOptions>;
  searchParams?: TransactionTypesSearchParamsType;
}

export const useTransactionTypes = ({ queryConfig, searchParams }: UseTransactionTypesOptions = {}) => {
  return useQuery({
    ...getTransactionTypesQueryOptions(searchParams),
    ...queryConfig,
  });
};

export const useSuspenseTransactionTypes = ({ queryConfig, searchParams }: UseTransactionTypesOptions) => {
  return useSuspenseQuery({
    ...getTransactionTypesQueryOptions(searchParams),
    ...queryConfig,
  });
};
